import { giphyLightGrey, giphyLightCharcoal } from '@giphy/js-brand'
import styled, { css } from 'styled-components'

export const Content = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 160px;
    padding: 8px 14px;
    height: 34px;
    background: #1e1e1e;
    border-radius: 4px;
`

export const FlagContent = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Container = styled.div<{ isMobile: boolean }>`
    position: fixed;
    left: 15px;
    bottom: 15px;

    ${({ isMobile }) =>
        isMobile &&
        css`
            position: absolute;
            width: calc(100vw - 20px);
            top: 0;
            bottom: auto;
            left: 0;
            background: #121212;
            padding: 5px 10px;

            ${Content} {
                justify-content: space-between;
            }

            ${SwitchButton} {
                margin-top: 0;
            }

            ${FlagContent} {
                width: auto;
            }
        `}
`

export const Text = styled.div`
    color: ${giphyLightGrey};
    margin-left: 6px;
    font-size: 15px;
    font-family: 'interface';
    font-weight: 400;
    cursor: pointer;
`

export const SpanishFlag = () => {
    return (
        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.25 2.375C0.25 1.47754 0.977537 0.75 1.875 0.75H11.125C12.0225 0.75 12.75 1.47754 12.75 2.375V8.29167C12.75 9.18913 12.0225 9.91667 11.125 9.91667L3.45811 9.91644L0.25 13.25V2.375Z"
                fill="url(#paint0_linear_16_465)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_16_465"
                    x1="-1.68319"
                    y1="11.5242"
                    x2="16.1807"
                    y2="1.48415"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF6666" />
                    <stop offset="1" stopColor="#FFF35C" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const PortugueseFlag = () => {
    return (
        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.25 2.375C0.25 1.47754 0.977537 0.75 1.875 0.75H11.125C12.0225 0.75 12.75 1.47754 12.75 2.375V8.29167C12.75 9.18913 12.0225 9.91667 11.125 9.91667L3.45811 9.91644L0.25 13.25V2.375Z"
                fill="url(#paint0_linear_16_34)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_16_34"
                    x1="12.75"
                    y1="3.4279"
                    x2="0.25"
                    y2="10.5721"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00FF99" />
                    <stop offset="1" stopColor="#00CCFF" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const SwitchButton = styled.div`
    color: ${giphyLightCharcoal};
    font-size: 15px;
    font-family: 'interface';
    font-weight: 400;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
`
